import React from "react";
import {Typography, useTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {formatCurrency, formatDate, formatPercent} from "../../utils/formatters";

export const InactiveAccountsAlertTable = ({data, loading}) => {
    const theme = useTheme();
    const dims = theme.dimensions;

    const common = {sortable: true, disableColumnMenu: true, headerClassName: 'table-header'};
    const colDefs = [
        {...common, type: 'text', width: 340, headerAlign: 'left', field: 'account_name', headerName: 'Account'},
        {...common, type: 'text', width: 140, headerAlign: 'left', field: 'location_name', headerName: 'Sales Territory'},
        {...common, type: 'text', width: 185, headerAlign: 'left', field: 'sales_person_name', headerName: 'Sales Person'},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'last_order_date', headerName: 'Last Order Date', valueFormatter: v => formatDate(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'days_since_last_order', headerName: 'Days Since Order'},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'avg_order_value', headerName: 'Avg Order Value', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'net_revenue', headerName: 'Lost Net Revenue', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 180, headerAlign: 'right', field: 'pocket_price_margin', headerName: 'Lost Pocket Margin', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'pocket_price_margin_percent', headerName: 'Pocket Margin %', valueFormatter: v => formatPercent(v, 2)}
    ];

    const determineRowClass = (params) => {
        return params.indexRelativeToCurrentPage % 2 === 1 ? 'table-row-odd' : 'table-row-even';
    };

    return (
        <div style={{width: dims.contentWidth}}>
            <Typography variant="h6" color="inherit" style={{marginBottom: 10}}>Account(s) With No Purchases In Last 6 Months</Typography>
            <DataGrid columns={colDefs} rows={data} loading={loading}
                      columnHeaderHeight={30} rowHeight={30} autoHeight
                      getRowClassName={params => determineRowClass(params)}
                      initialState={{
                          pagination: {paginationModel: {pageSize: 10}},
                          sorting: {sortModel: [{field: 'pocket_price_margin', sort: 'desc'}]}
                      }}
                      pageSizeOptions={[10, 25]}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
};